import { LOGIN_SUCCESSFUL, SUCCESSFUL_GET_USER_INFO } from './actionConst';

const initialState = {
    data: {
        id: "",
        username: "",
        completeName: "",
        firstName: "",
        lastName: "",
        email: "",
        photoUrl: "",
        partyType: "",
        address: "",
        company: {}
    },
    access_token: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case LOGIN_SUCCESSFUL:
            return {
                ...state,
                data: action.payload.user,
                token: action.payload.token
            }
        case SUCCESSFUL_GET_USER_INFO:
            return {
                ...state,
                data: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user/userReducer.js